import {getElemsByXPath, getIdentityParents, getParents, hasElementsByXPathList, isParentForElem} from "../utils/utils";
import {Fields} from "./fields";
import {Segment} from "./segment";
import block_extend from "./xpath_extend/block";
import element_extend from "./xpath_extend/element";


export const CLASS_MARKED_ELEM = "pi-perm-marked"


/*
Если у нас есть поддерево элементов, на каждом уровне которого ровно один элемент без текста
(кроме листового), то берём самый нижний элемент или ближайший из уже отмеченных.

Пример: <div>Тест: <div><p class="pi-perm-marked"><b>тест</b><p></div>

В этом случае при клике на <b> алгоритм в этом случае возьмёт второй div, что позволит пользователю снять маркировку.

При этом, если в дереве нет промаркированных элементов, то берем самый верхний.
*/
export function getNearMarkedParent(elem: HTMLElement, is_crawl_schema: boolean = false): HTMLElement {
    for (const el of getIdentityParents(elem)) {
        if (el.classList.contains(CLASS_MARKED_ELEM)) {
            return el
        }
    }

    if (is_crawl_schema && elem.tagName != "A") {
        // Если мы хотим разметить ссылку и нажали на элемент в котором нет ссылок, то ищем ссылку среди родителей и
        // выделяем её
        if (!hasElementsByXPathList(elem, [".//a"])) {
            for (const el of getParents(elem)) {
                if (el.tagName == "A") {
                    return el
                }
            }
        }
    }

    return elem
}


/*
Класс отвечающий за действие над полями и визуализации полей в DOM дереве.
 */
export class FieldsController {
    enabled: boolean
    document: Document

    fields: Fields

    constructor(document: Document) {
        this.enabled = true
        this.document = document
        this.fields = new Fields(this.document, null)
    }

    setModel(newModel: Fields) {
        Segment.resetSegments(this.document);
        this.fields = newModel;
        for (const field of this.fields.fields.values()) {
            field.updateMarks();

            for (const elemToMark of field.getElements()) {
                this.markElement(elemToMark);
            }
        }

        this.unmarkNonFieldsElems();
    }

    extendElement(elem: HTMLElement) {
        const newModel = element_extend.extendModel(this.fields, elem);
        if (!newModel) {
            return
        }

        this.setModel(newModel)
    }

    extendBlock(segment: HTMLElement) {
        const newModel = block_extend.extendModel(this.fields, segment);
        if (!newModel) {
            return
        }

        this.setModel(newModel)
    }

    unextendBlock(segment: HTMLElement) {
        const newModel = block_extend.unextendModel(this.fields, segment);
        if (!newModel) {
            return
        }

        this.setModel(newModel)
    }

    getNearBlock(elem: HTMLElement): HTMLElement | null {
        if (!this.fields.blockXPath) {
            return null
        }
        const blocks = getElemsByXPath(this.document, this.document.getRootNode() as HTMLElement, this.fields.blockXPath);
        for (const block of blocks) {
            if (isParentForElem(elem, block)) {
                return block
            }
        }

        return null;
    }

    getFieldsForElem(elem: HTMLElement): Set<string> {
        const ret = new Set<string>();

        for (const field of this.fields.fields.values()) {
            if (field.contains(elem)) {
                ret.add(field.name);
            }
        }
        return ret
    }

    selectElem(field: string, elem: HTMLElement) {
        this.fields.fields.get(field)!.addElem(elem);

        for (const field of this.fields.fields.values()) {
            for (const target of field.getElements()) {
                this.markElement(target);
            }
        }
    }

    unselectElem(field: string, elem: HTMLElement) {
        this.fields.fields.get(field)!.removeElem(elem);

        // Если после того, как с элемента сняли пометку у нас вообще не осталось помеченных элементов, то
        // удаляем информацию об обощении блока данных, т.к. обобщать нечего.
        let anyFieldExists = false;
        this.fields.fields.forEach((val) => {
            anyFieldExists = anyFieldExists || val.xpath_list.size > 0
        })

        if (!anyFieldExists) {
            this.fields.blockXPath = null;
        }

        this.unmarkNonFieldsElems();
    }

    markElement(elem: HTMLElement) {
        if (!elem.classList.contains(CLASS_MARKED_ELEM)) {
            elem.classList.add(CLASS_MARKED_ELEM);
        }

        Segment.addToSegments(elem)
    }

    // Снимает маркировку с тех html элементов, которые не состоят ни в одном поле.
    unmarkNonFieldsElems() {
        const toUnmark = new Array<HTMLElement>();
        for (const elem of this.document.getElementsByClassName(CLASS_MARKED_ELEM)) {
            let fields = this.getFieldsForElem(elem as HTMLElement);

            if (fields.size == 0) {
                toUnmark.push(elem as HTMLElement);
            }
        }

        for (const elem of toUnmark) {
            elem.classList.remove(CLASS_MARKED_ELEM);
            Segment.removeFromSegments(elem);
        }
    }
}
